import { createFragmentRegistry } from '@apollo/client/cache';

import { BoardFragments } from '../queries/fragments/boardFragments';
import { BucketFragments } from '../queries/fragments/bucketFragments';
import { DriverFragments } from '../queries/fragments/driverFragments';
import { GigEventFragments } from '../queries/fragments/gigEventFragments';
import { GigFragments } from '../queries/fragments/gigFragments';
import {
  GigLocationFragments
} from '../queries/fragments/gigLocationFragments';
import { LabelFragments } from '../queries/fragments/labelFragments';
import { NoteFragments } from '../queries/fragments/noteFragments';
import { OfferFragments } from '../queries/fragments/offerFragments';

export const ApolloFragmentRegistry = {
  fragments: createFragmentRegistry(
    ...[
      ...GigFragments,
      ...BucketFragments,
      ...BoardFragments,
      ...GigEventFragments,
      ...NoteFragments,
      ...LabelFragments,
      ...GigLocationFragments,
      ...DriverFragments,
      ...OfferFragments
    ]
  )
};
